module.exports = __webpack_public_path__ + "img/pic6.090ba9c4.jpg";